module.exports = __webpack_public_path__ + "img/icon_lock2.2c4d8d29.svg";